export const MENU_WAIT_MIN = 1;
export const MENU_WAIT_MAX = 10;
export const RE_PROMPT_MIN = 0;
export const RE_PROMPT_MAX = 3;

export const DTMF_OPTIONS = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
].map((d) => ({ value: d, label: d }));

export function clampNumericText(
  raw: string,
  min: number,
  max: number,
): string {
  const stripped = raw.replace(/\D/g, '');
  if (!stripped) return '';
  const n = Number(stripped);
  if (n < min) return String(min);
  if (n > max) return String(max);
  return String(n);
}

export type PromptCategory =
  | 'welcome'
  | 'menu'
  | 'noinput'
  | 'wronginput'
  | 'thanks'
  | 'noagent';
